import { takeLatest, call, put, all, delay } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/rotasp/api';
import { PATH_AAC_API } from 'services/rotasp/path';

// STORE
import { ReducerActionRotaSP } from 'store/modules/types';

// ACTIONS
import { baixarArquivosRequest } from 'store/modules/api/utils/arquivos/baixarArquivos/actions';
import { setLoader } from 'store/modules/app/loader/actions';
import { emissaoAtestadosSuccess, emissaoAtestadosFailure } from './actions';

// TYPES
import { Types, RequestEmissaoAtestados } from './types';

function* emissaoAtestadosRequest(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: RequestEmissaoAtestados } = request;

	const response: ApiResponse = yield call(
		postApi,
		token || '',
		PATH_AAC_API,
		`v3/central-liberacao/atendimentos/atestados`,
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		if (response.data && response.data.pdfDataUrl) {
			setLoader(true);
			yield delay(3000);
			yield put(
				baixarArquivosRequest(token || '', {
					url: response.data.pdfDataUrl,
					instanceRequest: 'aac',
				}),
			);
		}
		yield put(emissaoAtestadosSuccess(response.data));
	} else if (response.error) {
		yield put(emissaoAtestadosFailure());
	}
}

export default all([
	takeLatest(Types.EMISSAO_ATESTADOS_REQUEST, emissaoAtestadosRequest),
]);
